import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { KeyModifier } from './KeyModifier'
import { setModifierKeyState, TriState, uncheckActive,
  uncheckAlwaysOn, Platforms } from '../../actions/toolbar'
import { Permissions } from '../../lib/Permissions'

import '../../styles/toolbar.scss'

class KeysModifiersComponent extends Component {
  getActionForState = (oldState, newState) => {
    if (oldState === TriState.Active && newState === TriState.Inactive) {
      return this.props.uncheckActiveAction
    } else if (oldState === TriState.AlwaysOn && newState === TriState.Inactive) {
      return this.props.uncheckAlwaysOnAction
    }
    return null
  }

  metaOnStateChanged = (oldState, newState) => {
    const action = this.getActionForState(oldState, newState)
    if (action) { action('Meta') }
    this.props.setModifierKeyStateAction({ key: 'Meta', state: newState })
  }

  controlOnStateChanged = (oldState, newState) => {
    const action = this.getActionForState(oldState, newState)
    if (action) { action('Control') }
    this.props.setModifierKeyStateAction({ key: 'Control', state: newState })
  }

  shiftOnStateChanged = (oldState, newState) => {
    const action = this.getActionForState(oldState, newState)
    if (action) { action('Shift') }
    this.props.setModifierKeyStateAction({ key: 'Shift', state: newState })
  }

  altOnStateChanged = (oldState, newState) => {
    const action = this.getActionForState(oldState, newState)
    if (action) { action('Alt') }
    this.props.setModifierKeyStateAction({ key: 'Alt', state: newState })
  }

  renderKeyModifiers = () => {
    const {
      platformType,
      videoNotAvailable,
      modifierState,
    } = this.props
    if (platformType === Platforms.IOS) {
      return null
    }
    const disabled = (!Permissions.isMouseKbdAllowed() || videoNotAvailable)
    return (
      <>
        <div className='tbDivider' />

        <div className='tbArea tbKeyArea'>
          <KeyModifier
            id='Meta'
            state={modifierState.Meta}
            platform={platformType}
            onStateChanged={this.metaOnStateChanged}
            disabled={disabled}
          />
          <KeyModifier
            id='Control'
            state={modifierState.Control}
            platform={platformType}
            onStateChanged={this.controlOnStateChanged}
            disabled={disabled}
          />
          <KeyModifier
            id='Alt'
            state={modifierState.Alt}
            platform={platformType}
            onStateChanged={this.altOnStateChanged}
            disabled={disabled}
          />
          <KeyModifier
            id='Shift'
            state={modifierState.Shift}
            platform={this.props.platformType}
            onStateChanged={this.shiftOnStateChanged}
            disabled={disabled}
          />
        </div>
      </>
    )
  }

  render () {
    return this.renderKeyModifiers()
  }
}

KeysModifiersComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

KeysModifiersComponent.propTypes = {
  modifierState: PropTypes.object.isRequired,
  setModifierKeyStateAction: PropTypes.func.isRequired,
  uncheckActiveAction: PropTypes.func.isRequired,
  uncheckAlwaysOnAction: PropTypes.func.isRequired,
  platformType: PropTypes.string,
  videoNotAvailable: PropTypes.bool.isRequired,
}

export function mapStateToProps (state) {
  return {
    modifierState: state.toolbar.modifiers,
    platformType: Object.values(Platforms).includes(state.signaling.agentDetails.platformType)
      ? state.signaling.agentDetails.platformType
      : 'windows',
  }
}

function mapDispatchToProps (dispatch) {
  return {
    setModifierKeyStateAction: (payload) => {
      dispatch(setModifierKeyState(payload))
    },
    uncheckActiveAction: () => {
      dispatch(uncheckActive())
    },
    uncheckAlwaysOnAction: (payload) => {
      dispatch(uncheckAlwaysOn(payload))
    },
  }
}

export const KeysModifiers = connect(
  mapStateToProps,
  mapDispatchToProps
)(KeysModifiersComponent)
